import officeClient from './officeClient';
import { IOnlineObject, IOnlineArticle } from '@/types/api-responses';

const toOnline = (value: unknown): number =>
    (value === true || value === 1 || value === '1' || value === 'true' || value === 'True') ? 1 : 0;

export async function GetOnlineObjects() {
    const { data } = await officeClient.GET('/api/v1/office/pharmacies');
    const list = (data ?? []) as unknown as IOnlineObject[];
    return list.map(item => ({ ...item, online: toOnline(item.online) }));
}

export async function SetOnlineObjects(obj_id: number, status: number) {
    const { data } = await officeClient.PATCH('/api/v1/office/pharmacies/{objId}/online', {
        params: { path: { objId: obj_id } },
        body: { online: status === 1 },
    });
    return data;
}

export async function GetOnlineArticles() {
    const { data } = await officeClient.GET('/api/v1/office/articles');
    return (data ?? []) as unknown as IOnlineArticle[];
}

export async function SetOnlineArticles(id: number, status: number) {
    const { data } = await officeClient.PATCH('/api/v1/office/articles/{id}/online', {
        params: { path: { id } },
        body: { online: status === 1 },
    });
    return data;
}